__turbopack_context__.v({
  "body": "UtxoItem-module__eHihya__body",
  "btc": "UtxoItem-module__eHihya__btc",
  "icon": "UtxoItem-module__eHihya__icon",
  "left": "UtxoItem-module__eHihya__left",
  "linkRoot": "UtxoItem-module__eHihya__linkRoot",
  "root": "UtxoItem-module__eHihya__root",
  "usd": "UtxoItem-module__eHihya__usd",
});
